import * as React from 'react';

import {CustomizeFields} from 'shells/customize-fields/customize-fields';
import {mapFieldsToSelectableFields} from 'shells/customize-fields/helpers';
import type {EntityFormType, SelectableField} from 'shells/customize-fields/types';

import {useGetSchemaFieldsForEntityType} from '../../entity-form/forms/helpers';

import {translateEntityFormTypeToFieldEntityType} from './helpers';
import {useGetSelectedFields} from './use-get-selected-fields';
import {useUpdateFields} from './use-update-fields';

type Props = {
    onClose: () => void;
    entityType: EntityFormType;
};

export function CustomizeFieldsWrapper(props: Props) {
    const [isSaving, setIsSaving] = React.useState<boolean>(false);
    const {fields, refetch: refetchFields} = useGetSelectedFields(
        translateEntityFormTypeToFieldEntityType(props.entityType)
    );
    const saveFields = useUpdateFields();
    const schemaFields = useGetSchemaFieldsForEntityType(props.entityType);
    const nutshellFields =
        schemaFields && schemaFields.filter((field) => !field.isCustomField && field.isAddable);
    const customFields = schemaFields && schemaFields.filter((field) => field.isCustomField);

    const handleSaveFields = (selectedFields: SelectableField[]) => {
        setIsSaving(true);
        const entityType = translateEntityFormTypeToFieldEntityType(props.entityType);
        saveFields({
            entityType,
            fields: selectedFields.map((field) => ({
                fieldId: field.fieldId,
                isRequired: field.isRequired,
            })),
        }).then(() => {
            refetchFields();
        });

        setTimeout(() => {
            setIsSaving(false);
            props.onClose();
        }, 1000);
    };

    return (
        <CustomizeFields
            selectedFields={mapFieldsToSelectableFields(fields)}
            // @ts-expect-error
            refetchFields={refetchFields}
            schemaFields={schemaFields}
            handleSaveFields={handleSaveFields}
            isSaving={isSaving}
            nutshellFields={nutshellFields}
            customFields={customFields}
            entityType={props.entityType}
            onClose={props.onClose}
        />
    );
}
